module.exports = __webpack_public_path__ + "static/media/tienda.5f383a49.svg";